<form [formGroup]="formGroup">

    <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
	<app-form-field  *ngIf="isAdmin" [type]="fields.client_id.type" [options]="fields.client_id.options"></app-form-field>
	<app-form-field [type]="fields.number_layouts.type" [options]="fields.number_layouts.options"></app-form-field>
	<app-form-field [type]="fields.layout_one.type" [options]="fields.layout_one.options"></app-form-field>
	<app-form-field *ngIf="formGroup.get('number_layouts') && formGroup.get('number_layouts').value === 2" [type]="fields.layout_two.type" [options]="fields.layout_two.options"></app-form-field>
	<app-form-field [type]="fields.active.type" [options]="fields.active.options"></app-form-field>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
